import { defineStore } from 'pinia'
import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import publishingApi from '@/helpers/publishingApi'

dayjs.extend(isSameOrAfter)

interface SyncOpsStore {
  syncOp: SyncOp | Record<string, never>,
  syncOps: SyncOp[],
}

export const useSyncOpsStore = defineStore('syncOps', {
  state: () => ({
    syncOp: {},
    syncOps: [],
  }) as SyncOpsStore,

  getters: {
    availableSyncOps: state => state.syncOps
      .filter(syncOp => dayjs(syncOp.deadline).isSameOrAfter(dayjs(), 'day'))
      .sort((a, b) => new Date(a.deadline).getTime() - new Date(b.deadline).getTime()),
  },

  actions: {
    async applyForSyncOp(syncOpportunity: number, musicWork: number, details: string) {
      const { data } = await publishingApi.post('/sync-opportunity-applicants', {
        syncOpportunity,
        musicWork,
        details,
      })

      return data
    },
    async getSyncOps(page = 1) {
      const { data: { data } } = await publishingApi.get('/sync-opportunities', {
        params: {
          page,
          notExpired: true,
        },
      })

      this.syncOps = data
    },
    async getSyncOp(id: number) {
      const { data } = await publishingApi.get(`/sync-opportunities/${id}`)
      this.syncOp = data
    },
  },
})
